import { getWuiOverlaysApi } from '@jwplayer/wui-react';
import { MocksSlideOut } from '/debug/components/mocks-slide-out';
import { DebugSlideOut } from '/debug/components/settings-slide-out';
import { redirect } from '/module/routing/module';
import type { RouteName } from '../../../../module/routing/types';

interface SettingsItem {
  name: string;
  link: RouteName;
}

export const USER_MENU_SECTIONS = [
  {
    displayName: '',
    links: [
      {
        name: 'Profile',
        link: 'accountProfile',
      },
      {
        name: 'System usage',
        link: 'accountUsage',
      },
    ],
  },
  {
    displayName: 'Admin',
    links: [
      {
        name: 'Users & properties',
        link: 'accountUsersProperties',
      },
      {
        name: 'Developer tools',
        link: 'accountDeveloperTools',
      },
      {
        name: 'Billing',
        link: 'accountBilling',
      },
    ],
  },
] as const;

export const USEFUL_LINKS = [
  { link: 'https://docs.jwplayer.com/platform/docs/', name: 'Documentation', target: '_blank' },
  { link: 'https://jwplayer.com/legal', name: 'Privacy & legal', target: '_blank' },
] as const;

export const DEV_ONLY = [
  {
    name: 'Debug',
    onClick: () => {
      getWuiOverlaysApi().SlideOut.createAndOpen('debug-slide-out', (props) => <DebugSlideOut {...props} />, {
        blocking: false,
        headerTitle: 'Dashboard debug settings',
      });
    },
    dataTest: 'open-debug-slide-out',
  },
  {
    name: 'Mocks',
    onClick: () => {
      getWuiOverlaysApi().SlideOut.createAndOpen('mocks-slide-out', (props) => <MocksSlideOut {...props} />, {
        blocking: false,
        headerTitle: 'Mock settings',
      });
    },
    dataTest: 'open-mocks-slide-out',
  },
  {
    name: 'Components',
    onClick: () => {
      redirect({
        to: {
          pathname: 'internalComponents',
        },
      });
    },
    dataTest: 'main-nav-link-internal-components',
  },
] as const;

export const SETTINGS_ITEMS: SettingsItem[] = [];
